import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const MAX_RECENT_CLIENTS = 5;

export const SETUP_FILTER = {
  ALL: 'all',
  NEEDS_SETUP: 'needs-setup',
};

const useConsultantOverviewStore = create(
  persist(
    (set) => ({
      // Modal states
      showCreateOperatorModal: false,
      setShowCreateOperatorModal: (show) => set({ showCreateOperatorModal: show }),

      // List filters — module-level so a client round-trip keeps them, but not
      // persisted across reloads. The search query is local to the list.
      countryFilter: '',
      setupFilter: SETUP_FILTER.ALL,
      setCountryFilter: (country) => set({ countryFilter: country }),
      setSetupFilter: (setupFilter) => set({ setupFilter }),
      resetFilters: () => set({ countryFilter: '', setupFilter: SETUP_FILTER.ALL }),

      // Recently opened clients — ids only, newest first, capped. Per browser;
      // names always come from the live list, so stale ids just drop out.
      recentClientIds: [],
      recordRecentClient: (id) =>
        set((state) => ({
          recentClientIds: [id, ...state.recentClientIds.filter((x) => x !== id)].slice(
            0,
            MAX_RECENT_CLIENTS,
          ),
        })),

      // Consultant organization ID for switching back
      consultantOrgId: null,
      setConsultantOrgId: (orgId) => set({ consultantOrgId: orgId }),
      clearConsultantOrgId: () => set({ consultantOrgId: null }),
    }),
    {
      name: 'consultant-overview-storage', // unique name for localStorage key
      partialize: (state) => ({
        consultantOrgId: state.consultantOrgId,
        recentClientIds: state.recentClientIds,
      }),
    },
  ),
);

export default useConsultantOverviewStore;
